var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('macrotags-form',{attrs:{"keyword":_vm.keyword,"disabled":_vm.disabled,"showLabels":true},on:{"activate-mod":function($event){return _vm.activateMod()},"click":function($event){return _vm.updateMacrotag()}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-444e0712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/macrotags/Show.vue
// module id = TWpG
// module chunks = 1